const drone = {
  "page": {
    "loading": "드론 화면을 불러오는 중입니다...",
    "projectLoadFailed": "현장 정보를 불러오지 못했습니다",
    "projectNoLocation": "현장 위치가 없어 지도를 그릴 수 없습니다",
  },
  "sidebar": {
    "mapping": "매핑",
    "settings": "드론 설정",
  },
  "unavailable": {
    "title": "드론 API 준비 중",
    "body": "독 API 가 아직 연결되지 않았습니다. 개발 환경에서는 NEXT_PUBLIC_DRONE_API=mock 으로 목업을 볼 수 있습니다.",
  },
  "access": {
    "locked": "역할을 확인하는 중입니다 — 쓰기 컨트롤이 잠겨 있습니다",
    "viewer": "보기 권한 — 독 추가·비행·명령·설정은 owner 만 할 수 있습니다",
  },
  "error": {
    "unavailable": "드론 API 가 아직 준비되지 않았습니다",
    "forbidden": "권한이 없습니다 — owner 만 할 수 있습니다",
    "not_found": "대상을 찾지 못했습니다",
    "conflict": "지금 상태와 맞지 않아 처리하지 못했습니다",
    "validation": "입력값을 확인하세요",
    "dock_busy": "독이 비행 중이라 지금은 할 수 없습니다",
    "network": "요청을 보내지 못했습니다 — 다시 시도하세요",
    "unconfirmed": "요청의 결과를 확인하지 못했습니다 — 비행 목록과 기체 상태를 확인하세요",
  },
  "dockBar": {
    "aircraftChange": "새 기체 {{sn}} 을(를) 보았습니다 — 확인하면 이 독에 묶입니다",
    "aircraftConfirm": "기체 묶기",
    "label": "드론스테이션",
    "add": "독 추가",
    "empty": "등록된 독이 없습니다",
    "loadFailed": "독 목록을 불러오지 못했습니다",
    "retry": "다시 불러오기",
    "unbound": "미연결",
    "bindFailed": "바인딩 실패",
    "flying": "비행 중",
    "resumeBinding": "{{name}} 바인딩 이어 하기",
    "noSelection": "독을 고르세요 — 모든 기능은 고른 독을 대상으로 합니다",
    "statusButton": "{{name}} 상태와 명령",
    "hmsCount": "HMS {{count}}건",
    "hmsNone": "HMS 없음",
  },
  "liveness": {
    "live": "정상 수신",
    "stale": "수신 지연",
    "offline": "오프라인",
  },
  "status": {
    "altitude": "상대 높이",
    "dockTitle": "독",
    "aircraftTitle": "기체",
    "mode": "작업 모드",
    "cover": "덮개",
    "climate": "공조",
    "temperature": "내부 온도",
    "humidity": "습도",
    "outsideTemperature": "외기 온도",
    "wind": "풍속",
    "network": "네트워크",
    "aircraftPower": "기체 전원",
    "charge": "기체 충전",
    "flightMode": "비행 모드",
    "battery": "배터리",
    "remain": "남은 비행 시간",
    "speed": "수평 속도",
    "lastSeen": "마지막 수신 {{time}}",
    "staleWarning": "10초 넘게 상태를 받지 못했습니다",
    "noTelemetry": "아직 받은 상태가 없습니다",
    "aircraftOff": "기체가 꺼져 있거나 연결되지 않았습니다",
    "commands": "명령",
    "coverOpen": "뚜껑 열기",
    "coverClose": "뚜껑 닫기",
    "powerOn": "기체 전원 켜기",
    "powerOff": "기체 전원 끄기",
    "busy": "비행 중에는 뚜껑·기체 전원 명령을 쓸 수 없습니다",
    "remove": "독 제외",
    "minutesSeconds": "{{minutes}}분 {{seconds}}초",
    "commandSent": "명령을 보냈습니다",
    "commandFailed": "{{dock}} · {{command}} 명령이 실패했습니다 — {{reason}}",
    "commandFailedNoReason": "{{dock}} · {{command}} 명령이 실패했습니다",
  },
  "enum": {
    "unknown": "알 수 없음({{value}})",
    "dockMode": {
      "0": "대기",
      "1": "현장 디버깅",
      "2": "원격 디버깅",
      "3": "펌웨어 업데이트 중",
      "4": "작업 중",
      "5": "보정 필요",
    },
    "cover": {
      "0": "닫힘",
      "1": "열림",
      "2": "반쯤 열림",
      "3": "덮개 상태 이상",
    },
    "climate": {
      "0": "대기",
      "1": "냉방 중",
      "2": "난방 중",
      "3": "제습 중",
      "7": "냉방 준비 중",
      "8": "난방 준비 중",
    },
    "onOff": {
      "0": "꺼짐",
      "1": "켜짐",
    },
    "networkQuality": {
      "0": "신호 없음",
      "1": "매우 나쁨",
      "2": "나쁨",
      "3": "보통",
      "4": "좋음",
      "5": "매우 좋음",
    },
    "aircraftMode": {
      "0": "대기",
      "1": "이륙 준비",
      "2": "이륙 준비 완료",
      "3": "수동 비행",
      "4": "자동 이륙",
      "5": "경로 비행",
      "9": "자동 귀환",
      "10": "자동 착륙",
      "11": "강제 착륙",
      "14": "연결 안 됨",
    },
  },
  "hms": {
    "title": "HMS 경보",
    "empty": "진행 중인 경보가 없습니다",
    "inSky": "비행 중 발생",
    "code": "코드 {{code}}",
    "level": {
      "0": "알림",
      "1": "주의",
      "2": "경고",
      "none": "등급 없음",
    },
  },
  "binding": {
    "passwordOnce": "비밀번호는 한 번만 보입니다 — 지금 복사하세요",
    "moveAsk": "독 {{sn}} 은(는) 다른 프로젝트에 등록돼 있습니다. 이 프로젝트로 옮길까요?",
    "moveConfirm": "이 프로젝트로 옮기기",
    "titleAdd": "독 추가",
    "titleResume": "{{name}} 바인딩 이어 하기",
    "stepsLabel": "연결 단계",
    "steps": {
      "1": "독 정보",
      "2": "연결값",
      "3": "앱 입력",
      "4": "접속 확인",
    },
    "currentStep": "{{index}}단계 / 4단계 — {{name}}",
    "snLabel": "독 SN",
    "snHelp": "독 뒷면 라벨 또는 DJI 앱 기기 정보의 시리얼 번호",
    "nameLabel": "독 이름",
    "register": "연결값 받기",
    "problem": {
      "snRequired": "SN 을 넣으세요",
      "snFormat": "영문 대문자·숫자 6~32자로 넣으세요",
      "snDuplicate": "이 프로젝트에 이미 등록된 SN 입니다",
      "nameRequired": "이름을 넣으세요",
      "nameTooLong": "40자 이하로 넣으세요",
    },
    "field": {
      "mqttPassword": "MQTT 비밀번호",
      "org_id": "조직 ID",
      "org_name": "조직 이름",
      "binding_code": "바인딩 코드",
      "mqtt": "MQTT 게이트웨이 주소",
      "mqttUser": "MQTT 계정",
      "ntp": "NTP 서버",
    },
    "onceNotice": "이 값은 지금 한 번만 보입니다. 창을 닫으면 다시 볼 수 없고, 다시 받으려면 재발급해야 합니다.",
    "reissuedNotice": "재발급했습니다 — 이전 연결값은 더 이상 쓸 수 없습니다.",
    "guideTitle": "DJI 앱에 연결값 입력",
    "guide": {
      "1": "DJI Pilot 2(또는 독 설정 앱)에서 독에 연결하고 「클라우드 서비스」를 엽니다.",
      "2": "「타사 클라우드」를 고르고 MQTT 게이트웨이 주소·계정과 NTP 서버를 넣습니다.",
      "3": "「조직 바인딩」에서 조직 ID 와 바인딩 코드를 넣고 독 이름을 확인합니다.",
      "4": "저장하면 독이 서버에 접속합니다. 다음을 눌러 접속을 기다리세요.",
    },
    "waiting": "독이 접속해 바인딩을 마치기를 기다리는 중입니다",
    "bound": "바인딩을 마쳤습니다 — 독 바에서 이 독을 고를 수 있습니다",
    "failed": "바인딩에 실패했습니다",
    "failure": {
      "invalid_binding_code": "바인딩 코드가 맞지 않습니다",
      "organization_mismatch": "다른 조직에 바인딩된 독입니다",
      "license_invalid": "독 라이선스 검증에 실패했습니다",
      "sn_mismatch": "접속한 독의 SN 이 등록한 SN 과 다릅니다",
      "unknown": "서버가 사유를 알리지 않았습니다",
    },
    "resumeIntro": "이전 연결값은 다시 볼 수 없습니다. 재발급하면 이전 값은 무효가 되고 새 값을 한 번 보여 줍니다.",
    "reissue": "연결값 재발급",
    "next": "다음",
    "back": "이전",
    "close": "닫기",
    "done": "완료",
    "copy": "{{label}} 복사",
    "copied": "복사했습니다",
  },
  "confirm": {
    "previewing": "서버가 이 명령을 판정하는 중입니다",
    "previewFailed": "미리 보기를 받지 못했습니다",
    "notSendable": "지금은 보낼 수 없습니다",
    "expired": "미리 보기의 유효 시간이 지났습니다 — 닫고 다시 여세요. 요청은 보내지 않았습니다.",
    "cancel": "취소",
    "confirm": "확인",
    "title": {
      "aircraft_limits": "기체 제한 적용",
      "eventAck": "경보 확인",
      "closeRecord": "닫기 기록",
      "aircraft": "기체 묶기",
      "cover_open": "뚜껑 열기",
      "cover_close": "뚜껑 닫기",
      "aircraft_power_on": "기체 전원 켜기",
      "aircraft_power_off": "기체 전원 끄기",
      "climate": "공조 바꾸기",
      "pause": "경로 일시정지",
      "resume": "경로 재개",
      "settings": "비행 설정 변경",
      "removeDock": "독 제외",
    },
    "body": {
      "aircraft_limits": "{{dock}} 기체에 비행 프로필의 제한 값을 겁니다.",
      "eventAck": "{{dock}} 의 경보를 확인합니다. 확인하면 이 경보는 이륙을 막지 않습니다.",
      "closeRecord": "{{dock}} 의 닫기 기록을 남깁니다 — {{reason}}.",
      "aircraft": "{{dock}} 에 기체 {{sn}} 을(를) 묶습니다.",
      "cover_open": "{{dock}}의 뚜껑을 엽니다.",
      "cover_close": "{{dock}}의 뚜껑을 닫습니다. 덮개 아래에 사람·물건이 없는지 확인하세요.",
      "aircraft_power_on": "{{dock}}의 기체 전원을 켭니다.",
      "aircraft_power_off": "{{dock}}의 기체 전원을 끕니다.",
      "climate": "{{dock}}의 공조를 「{{mode}}」(으)로 바꿉니다.",
      "pause": "{{dock}}의 경로 비행을 일시정지합니다. 기체는 그 자리에서 정지 비행합니다.",
      "resume": "{{dock}}의 경로 비행을 멈춘 자리부터 이어 갑니다.",
      "settings": "{{dock}}의 고도 한계를 최대 {{max}} m · 최저 {{min}} m 로 바꿉니다.",
      "removeDock": "{{dock}}을(를) 이 프로젝트에서 제외합니다. 다시 쓰려면 바인딩을 처음부터 해야 합니다.",
    },
  },
  "leave": {
    "title": "독이 떠 있습니다",
    "body": "페이지를 떠나도 비행은 계속되지만, 이 화면의 귀환 버튼과 지켜보기를 쓸 수 없게 됩니다. 떠나시겠습니까?",
    "stay": "머무르기",
    "leave": "떠나기",
  },
  "launch": {
    "blockedByPreparation": "아래를 풀면 이륙할 수 있습니다",
    "checkFailed": "확인 안 됨",
    "loginRemaining": "로그인 남은 시간",
    "loginMinutes": "{{minutes}}분",
    "loginShort": "발사에는 로그인이 90분 이상 남아 있어야 합니다 — 다시 로그인하세요",
    "title": "비행 실행 — 이륙 확인",
    "dock": "대상 독",
    "plan": "계획",
    "target": "사진을 받을 시계열",
    "figures": "경로 {{distance}} · 사진 약 {{photos}}장 · 약 {{minutes}}분",
    "checklistLegend": "항목마다 직접 확인하고 하나씩 체크하세요(기억하지 않습니다)",
    "validFor": "미리 보기 유효 {{seconds}}초 남음",
    "expired": "미리 보기의 유효 시간이 지났습니다 — 다시 미리 보세요. 요청은 보내지 않았습니다.",
    "reopen": "다시 미리 보기",
    "execute": "이륙",
    "noAutoResend": "기한이 지나면 요청을 다시 보내지 않습니다",
    "previewing": "서버가 이륙 확인을 만드는 중입니다",
    "previewFailed": "이륙 확인을 받지 못했습니다 — 다시 미리 보세요",
    "blocked": "지금은 이륙할 수 없습니다",
  },
  "safety": {
    "regionLabel": "비행 안전",
    "rth": "귀환",
    "rthAria": "{{dock}} 귀환 — 한 번 누르면 바로 보냅니다",
    "rthStage": {
      "sending": "보내는 중",
      "requested": "요청 접수 — 독 응답 대기",
      "notSent": "3초 안에 접수되지 않음 — 다시 누르세요",
      "refused": "독이 귀환을 거절함 — {{reason}}",
      "sendFailed": "보내지 못했습니다 — 다시 누르세요",
      "sendFailedReason": "보내지 못했습니다: {{reason}} — 다시 누르세요",
      "returning": "귀환 중",
      "landed": "착륙 완료",
    },
    "rthAccepted": "귀환 요청을 보냈습니다",
  },
  "attend": {
    "button": "지켜보는 중",
    "aria": "{{dock}} 지켜보기 — 운영자 부재 귀환 기한을 늘립니다",
    "sending": "지켜보기 보내는 중",
    "ok": "지켜보기 기한까지 {{minutes}}분 {{seconds}}초",
    "warning": "지켜보기 기한 {{seconds}}초 전 — 누르세요",
    "overdue": "지켜보기 기한 지남 — 서버가 귀환을 보냅니다",
    "unknown": "지켜보기 기한 모름",
    "absentReturn": "운영자 부재로 귀환을 시작했습니다",
  },
  "login": {
    "hours": "로그인 {{hours}}시간 {{minutes}}분 남음",
    "minutes": "로그인 {{minutes}}분 {{seconds}}초 남음",
    "unknown": "로그인 남은 시간 모름",
    "expiring": "로그인 15분 미만 — 곧 로그아웃됩니다",
    "expired": "로그인 만료 — 착륙 뒤 다시 로그인하세요",
  },
  "live": {
    "connecting": "라이브에 연결하는 중입니다",
    "waitingStream": "독이 영상을 보내기를 기다리는 중입니다",
    "playbackFailed": "라이브를 재생하지 못했습니다",
    "title": "{{dock}} 라이브",
    "cameraLabel": "카메라",
    "camera": {
      "dock": "독 카메라",
      "aircraft_wide": "기체 광각",
      "aircraft_zoom": "기체 줌",
      "aircraft_ir": "기체 열화상",
    },
    "open": "라이브 보기",
    "start": "라이브 시작",
    "fullscreen": "전체화면",
    "exitFullscreen": "전체화면 끝내기",
    "close": "라이브 닫기",
    "notStarted": "켜진 라이브가 없습니다",
    "viewerNotStarted": "owner 가 라이브를 켜면 볼 수 있습니다",
    "mockSource": "목업 영상",
    "videoLabel": "{{dock}} {{camera}} 영상",
  },
  "mapping": {
    "title": "매핑",
    "targetLabel": "대상 시계열 (사진을 받을 곳)",
    "targetNone": "대상 없음",
    "targetEmpty": "사진을 받을 수 있는 before 시계열이 없습니다 — 프로젝트 화면에서 시계열을 추가하세요",
    "substitute": "목업 대상 대용",
    "gate": {
      "noTarget": "사진을 받을 before 시계열을 고르세요",
      "notInProject": "이 프로젝트의 시계열이 아닙니다",
      "notBefore": "이 시계열은 사진을 받을 수 있는 상태(before)가 아닙니다",
      "hasPhotos": "사진을 직접 올린 시계열은 독 매핑 대상이 아닙니다",
      "pending": "시계열을 확인하는 중입니다",
      "unreadable": "시계열 목록을 불러오지 못했습니다",
      "readOnly": "매핑을 요청했습니다 — 이 시계열의 계획·사진은 읽기 전용입니다",
    },
  },
  "reference": {
    "label": "기준 시계열 (산출물·지형)",
    "none": "기준 없음",
    "noReferenceWarning": "기준 시계열이 없어 충돌 검증을 하지 않습니다",
    "layers": "겹쳐 볼 산출물",
    "ortho": "정사영상",
    "dsm": "DSM",
    "gis": "GIS 레이어",
    "gisEmpty": "이 프로젝트에 GIS 레이어가 없습니다",
    "no2d": "이 기준에는 2D 산출물이 없습니다",
    "model3d": "3D 모델·BIM 은 3D 뷰에서 봅니다",
  },
  "plans": {
    "deleting": "지우는 중 — 다시 지우면 끝납니다",
    "title": "비행계획",
    "new": "새 계획",
    "empty": "저장된 계획이 없습니다",
    "listLabel": "저장된 비행계획",
    "open": "{{name}} 열기",
    "duplicate": "{{name}} 복제",
    "delete": "{{name}} 삭제",
    "deleteTitle": "계획 삭제",
    "deleteMessage": "「{{name}}」 계획을 삭제합니다",
    "deleteSub": "삭제하면 되돌릴 수 없습니다",
    "import": "다른 프로젝트에서 가져오기",
    "importTitle": "다른 프로젝트 계획 가져오기",
    "importEmpty": "가져올 수 있는 계획이 없습니다",
    "importAction": "{{name}} 가져오기",
    "importButton": "가져오기",
    "farWarning": "가져온 계획 「{{name}}」의 영역이 이 현장에서 멀리 떨어져 있습니다 — 영역을 확인하세요",
    "kmzBadge": "KMZ",
    "readOnly": "읽기 전용",
    "copySuffix": "(사본)",
  },
  "area": {
    "title": "매핑 영역",
    "draw": "영역 그리기",
    "redraw": "다시 그리기",
    "drawing": "지도에서 점을 찍고 더블클릭으로 마칩니다 (Esc 로 취소)",
    "cancel": "그리기 취소",
    "none": "영역이 없습니다",
    "points": "꼭짓점 {{count}}개",
  },
  "params": {
    "speedCap": "이 독의 상한 {{cap}} m/s — 더 빨리 날려면 드론 설정에서 상한을 올리세요",
    "title": "비행·촬영 설정",
    "name": "계획 이름",
    "mode": "모드",
    "modes": {
      "single_grid": "싱글 그리드",
      "double_grid": "더블 그리드",
      "oblique": "경사촬영",
    },
    "gridAngle": "그리드 각도 (°)",
    "frontOverlap": "전방 중첩도 (%)",
    "sideOverlap": "측방 중첩도 (%)",
    "altitude": "비행 고도 (m)",
    "speed": "속도 (m/s)",
    "camera": "카메라",
    "cameras": {
      "visible": "광학",
      "thermal": "열화상",
      "both": "둘 다",
    },
    "overlapBasis": "중첩 기준",
    "obliquePattern": "경사 패턴",
    "obliquePatterns": {
      "single_grid": "싱글 그리드",
      "double_grid": "더블 그리드",
      "five_direction": "5방향",
    },
    "obliqueTilt": "경사 방향",
    "obliqueTilts": {
      "along_track": "진행 방향",
      "cross_track": "옆 방향",
    },
    "obliqueTiltHelp": "옆 방향은 줄에 수직인 두 방향을 봅니다. 도로·하천·사면처럼 긴 구역에서 긴 줄을 유지하며 옆면을 찍을 때 씁니다",
    "gimbalPitch": "카메라 각 (°)",
    "includeNadir": "정사 패스 함께",
    "sameDirectionOverlap": "같은 방향끼리의 측방 중첩은 {{same}}% 입니다 — 더 필요하면 측방 중첩을 올리거나 5방향을 쓰세요",
    "flightAreaHelp": "그린 매핑 영역은 촬영 영역입니다. 경사 줄은 그 밖의 비행 영역까지 날아가고, 영역 밖 비행은 이웃 부지 위를 지납니다. 그것을 막는 것은 독 거리 포락선뿐입니다",
    "save": "계획 저장",
    "saved": "계획을 저장했습니다",
  },
  "preview": {
    "title": "미리 보기 (추정)",
    "figures": "줄 {{lines}} · 사진 약 {{photos}}장 · {{distance}} · 약 {{minutes}}분 · GSD {{gsd}} cm/px",
    "invalid": "영역과 설정을 고치면 미리 보기가 보입니다",
    "obliqueFigures": "패스 {{passes}} · 보는 방향 {{directions}} · 경사 GSD {{gsd}} cm/px · 영역 밖 최대 {{outside}}",
    "covered": "영역 전부가 위험 지역과 완충 안이라 비행선이 없습니다",
  },
  "planForm": {
    "problem": {
      "required": "값을 넣으세요",
      "notNumber": "숫자를 넣으세요",
      "outOfRange": "{{min}}~{{max}} 사이로 넣으세요",
      "tooLong": "{{max}}자 이하로 넣으세요",
      "tooFewPoints": "영역을 {{min}}개 이상의 점으로 그리세요",
    },
  },
  "hazards": {
    "title": "위험 시설물·지역",
    "draw": "위험 지역 그리기",
    "show": "지도에 표시",
    "empty": "등록된 위험 시설물·지역이 없습니다",
    "drawing": "지도에서 다각형을 그리세요 (더블클릭으로 마침, Esc 취소)",
    "formTitle": "위험 시설물·지역 저장",
    "kind": {
      "facility": "시설물",
      "area": "지역",
    },
    "kindLabel": "종류",
    "name": "이름",
    "height": "높이 (m, 선택)",
    "heightValue": "높이 {{height}} m",
    "noHeight": "높이 미지정",
    "save": "저장",
    "cancel": "취소",
    "delete": "{{name}} 삭제",
    "alwaysAvoids": "표시를 꺼도 경로는 늘 위험 지역에서 {{buffer}} m 떨어져 만들어지고, 피할 수 없으면 막힙니다",
    "problem": {
      "nameRequired": "이름을 넣으세요",
      "height": "0~1000 사이 숫자로 넣으세요",
    },
  },
  "route": {
    "deleting": "이 경로는 지우는 중에 멈췄습니다 — 다시 생성하세요",
    "profileFailed": "경로 단면을 읽지 못했습니다",
    "title": "경로",
    "generate": "경로 생성·검증",
    "regenerate": "다시 생성",
    "invalid": {
      "noDock": "독 바에서 독을 고르세요",
      "missing": "이 계획·독의 경로가 없습니다 — 생성하세요",
      "otherDock": "다른 독으로 만든 경로입니다 — 다시 생성하세요",
      "stalePlan": "계획이 바뀌었습니다 — 다시 생성하세요",
      "hazardsChanged": "위험 지역이 바뀜 — 다시 만들기",
      "blocked": "경로가 막혀 실행할 수 없습니다",
    },
    "block": {
      "hazard": "위험 지역 「{{name}}」을(를) 지나 차단됐습니다",
      "hazard_takeoff_inside": "독이 위험 지역 「{{names}}」 안에 있어 경로를 만들 수 없습니다",
      "hazard_area_covered": "영역 전부가 위험 지역 「{{names}}」과 완충 안이라 경로를 만들 수 없습니다",
      "hazard_unreachable": "독에서 닿는 비행선이 없어 경로를 만들 수 없습니다 — 「{{names}}」이(가) 길을 막습니다",
      "hazard_detour_limit": "우회하면 경로점·거리·한 비행 한도를 넘어 경로를 만들 수 없습니다 — 「{{names}}」",
      "hazard_waypoint_inside": "웨이포인트가 위험 지역 「{{names}}」 안에 있어 경로를 만들 수 없습니다",
    },
    "figures": "웨이포인트 {{waypoints}} · 사진 약 {{photos}}장 · {{distance}} · 약 {{minutes}}분",
    "obliqueSummary": "경사 {{pattern}}{{tilt}} · 패스 {{passes}} · 영역 밖 최대 {{lead}}",
    "ready": "실행할 수 있는 경로입니다",
    "collision": "충돌 가능 구간 {{count}}곳 — 지형·구조물 여유 {{threshold}} m 미만",
    "noCollision": "기준 시계열 단면과 충돌 가능 구간이 없습니다",
    "noReference": "기준 시계열이 없어 단면과 충돌 표시를 하지 않습니다",
    "needSavedPlan": "계획을 저장하면 경로를 만들 수 있습니다",
    "avoidance": "위험 지역 {{count}}곳을 피함 · 우회 +{{bypass}} · 촬영하지 않는 면적 {{area}} m²({{ratio}}%)",
    "warning": {
      "hazard_waypoint_buffer": "경로점이 위험 지역 완충 안에 있습니다 — {{names}}",
      "hazard_excluded_area": "빠진 영역 {{area}} m²({{ratio}}%) — 이 자리는 비행선이 지나지 않습니다",
      "hazard_unreachable_part": "이을 수 없어 뺀 조각 {{area}} m² — 둘러싸여 닿을 길이 없습니다",
      "hazard_short_fragment": "짧은 조각 — 버림 {{dropped}}개({{length}}), 남김 {{kept}}개. 남긴 조각은 사진 중첩이 모자랄 수 있습니다",
      "hazard_edge_gap": "고도가 낮아 완충({{buffer}} m)이 촬영 폭 절반을 넘습니다 — 위험 지역 가장자리에 사진 공백이 생길 수 있습니다",
      "hazard_takeoff_buffer": "독이 「{{names}}」의 완충 안에 있습니다",
      "hazard_return_reach": "비상 귀환은 독까지 곧장 날아 「{{names}}」 위를 지날 수 있습니다",
    },
  },
  "legend": {
    "title": "범례",
    "nadirPass": "연직 패스 {{index}}",
    "obliquePass": "경사 패스 {{index}} · 보는 방향 {{bearings}}",
    "obliquePassSide": "경사 패스 {{index}} · 줄에 수직으로 봄 {{bearings}}",
    "route": "경로",
    "bypass": "우회 구간",
    "transit": "이동 구간(독 ↔ 경로)",
    "pathStart": "S 시작 표지",
    "pathEnd": "E 끝 표지",
    "returnExposure": "귀환 노출 구간",
    "collision": "충돌 가능 구간",
    "excluded": "빠진 영역",
    "unreachable": "이을 수 없는 조각",
    "hazard": "위험 지역",
    "causeHazard": "원인 구역(경로를 막거나 돌아가게 한 구역)",
    "area": "촬영 영역(매핑 영역)",
    "flightArea": "비행 영역 · 영역 밖 최대 {{outside}}",
    "waypoint": "경로점",
    "photo": "촬영점",
    "sight": "시선 표시",
    "dock": "독",
    "dockScene": "독과 귀환 고도선",
  },
  "profile": {
    "title": "경로 단면",
    "aria": "경로 단면 — 거리 {{distance}} 동안 지형과 비행 높이, 충돌 가능 구간 {{count}}곳",
    "terrain": "지형",
    "flight": "비행",
    "collision": "충돌 가능",
  },
  "flight": {
    "aircraftPending": "기체 연결 확인 중",
    "profileIncomplete": "비행 프로필이 불완전합니다 — 드론 설정에서 채우세요",
    "title": "비행",
    "run": "비행 실행",
    "phase": {
      "preparing": "준비 중",
      "takeoff": "이륙",
      "en_route": "진입",
      "mapping": "촬영",
      "returning": "귀환",
      "landing": "착륙",
      "landed": "착륙 완료",
      "failed": "실패",
    },
    "paused": "일시정지됨",
    "pause": "일시정지",
    "resume": "재개",
    "progress": "웨이포인트 {{index}}/{{total}} · {{percent}}%",
    "battery": "배터리 {{percent}}%",
    "photos": "누적 사진 {{count}}장",
    "openLive": "라이브",
    "needRoute": "실행할 수 있는 경로가 없습니다",
    "dockBusy": "이 독은 이미 비행 중입니다",
    "needTarget": "사진을 받을 대상 시계열을 고르세요",
    "launched": "이륙 요청을 보냈습니다",
  },
  "request": {
    "title": "매핑 요청",
    "action": "매핑 요청",
    "flying": "비행 중에는 요청할 수 없습니다",
    "noPhotos": "아직 받은 사진이 없습니다",
    "substituteTitle": "대용 시계열 매핑 요청",
    "substituteBody": "목업 대상 대용이라 실제 서버로 보내지 않고 이 화면의 상태만 바꿉니다.",
    "done": "요청 완료",
  },
  "flightCheck": {
    "terrainVersion": "검증한 지형 판: {{version}}",
    "title": "비행 검증",
    "run": "비행 검증",
    "rerun": "다시 검증",
    "passed": "통과 · {{time}}",
    "problem": {
      "unchecked": "비행 검증을 아직 하지 않았습니다",
      "failed": "비행 검증을 통과하지 못했습니다",
      "stale": "기록이 낡았습니다 — 다시 검증하세요",
    },
    "stale": {
      "profile_changed": "비행 프로필이 바뀜",
      "hazards_changed": "위험 지역이 바뀜",
      "terrain_changed": "지형이 바뀜",
      "validator_changed": "검증기가 바뀜",
      "validator_unreviewed": "검토되지 않은 검증기",
      "kmz_changed": "경로 파일이 바뀜",
    },
  },
  "preparation": {
    "title": "비행 준비",
    "residual": "이 독의 지난 비행이 닫히지 않았습니다 — 착륙을 확인해 기록하세요",
    "eventNotFound": "이 화면에서 경보를 찾지 못했습니다 — {{reason}} (사건 {{id}}). 사건 번호로 다른 길에서 확인하세요.",
    "limitsIntro": "기체를 켜고, 프로필의 제한을 기체에 걸고, 끕니다. 단계마다 서버가 판정합니다. 켜진 뒤에 다음 단계를 누르세요.",
    "power": "기체 전원: {{state}}",
    "stepSent": "보냄",
    "stepRun": "실행",
    "done": "준비 마침",
    "closeIntro": "서버가 놓친 착륙을 사람이 남기는 기록입니다. 기체가 어디 있는지 직접 확인하고 고르세요.",
    "closeNext": "미리 보기",
    "reasonLabel": "닫기 사유",
    "noteLabel": "메모(선택)",
    "action": {
      "limits": "기체 제한 준비",
      "ack": "경보 확인",
      "close": "닫기 기록",
    },
    "step": {
      "power_on": "기체 켜기",
      "limits": "기체 제한 적용",
      "power_off": "기체 끄기",
    },
    "reason": {
      "in_dock_visual": "독 안(눈으로)",
      "landed_outside_visual": "독 밖 착륙(눈으로)",
      "recovered_outside_dock": "독 밖에서 수거",
      "lost": "잃음",
      "destroyed": "부서짐",
    },
    "reasonHint": {
      "in_dock_visual": "기체가 독 안에 있는 것을 눈으로 봤습니다. 다음 비행 준비는 이 기록이 있어야 열립니다.",
      "landed_outside_visual": "기체가 독 밖에 내린 것을 눈으로 봤습니다.",
      "recovered_outside_dock": "기체를 독 밖에서 거두었습니다.",
      "lost": "기체를 찾지 못했습니다.",
      "destroyed": "기체가 부서졌습니다.",
    },
  },
  "settings": {
    "profile": "비행 프로필",
    "profileUnreadable": "저장된 프로필을 읽지 못했습니다",
    "incomplete": "프로필이 불완전합니다 — 비행 계열이 열리지 않습니다",
    "digest": "저장된 digest {{digest}}",
    "groupRequired": "필수 항목",
    "groupLimits": "비행 한계",
    "groupTakeoff": "이륙 조건",
    "groupWatch": "감시·조종 값",
    "positionSuggested": "독이 보고한 위치를 채워 두었습니다 — 확인해 저장해야 값이 됩니다",
    "fieldRequired": "값을 넣으세요",
    "fieldRange": "{{min}}~{{max}}",
    "saveProfile": "프로필 저장",
    "confirmChanged": "바뀌는 항목: {{fields}}",
    "confirmNoChange": "없음",
    "confirmDigest": "새 digest 앞 8자: {{digest}}",
    "confirmComplete": "저장하면 프로필이 완전합니다",
    "confirmIncomplete": "저장해도 불완전합니다: {{problems}}",
    "aircraftLimits": "기체 제한 기대값",
    "changes": "변경 기록",
    "changesEmpty": "아직 변경 기록이 없습니다",
    "climateSaved": "저장된 모드: {{mode}}",
    "climateSave": "모드 저장",
    "field": {
      "latitude": "독 위도",
      "longitude": "독 경도",
      "height_m": "독 타원체 높이 (m)",
      "dock_position": "독 위치",
      "max_distance_m": "최대 거리 (m)",
      "max_height_m": "최대 고도 (m)",
      "min_height_m": "최저 고도 (m)",
      "rth_altitude_m": "귀환 고도 (m)",
      "permit_ceiling_m": "허가 상한 (m)",
      "max_speed_mps": "최대 속도 (m/s)",
      "temp_min_c": "최저 기온 (℃)",
      "temp_max_c": "최고 기온 (℃)",
      "max_wind_mps": "최대 풍속 (m/s)",
      "min_battery_pct": "최소 배터리 (%)",
      "min_gnss_quality": "GNSS 품질 하한",
      "min_gps_number": "위성 수 하한",
      "link_stable_s": "끊김 없는 접속 (초)",
      "breach_margin_m": "이탈 감시 여유 (m)",
      "position_tolerance_m": "독 위치 허용 차이 (m)",
      "attend_timeout_s": "운영자 부재 감시 (초)",
      "telemetry_lost_s": "원격 측정 끊김 판정 (초)",
      "route_max_points": "경로점 수 상한",
      "hover_max_s": "호버 상한 (초)",
      "stick_max_deflection": "조종간 최대 편향",
      "stick_session_max_s": "조종 세션 길이 (초)",
      "stick_floor_m": "조종간 하한 (m, off 가능)",
      "stick_descent_mps": "하한 투영 하강 속도",
      "climate_mode": "독 공조 모드",
      "obstacle_avoidance": "장애물 감지",
    },
    "title": "드론 설정",
    "selectDock": "독 바에서 독을 고르세요",
    "viewOnly": "보기 권한 — 설정을 바꿀 수 없습니다",
    "loadFailed": "설정을 불러오지 못했습니다",
    "climate": "독 내부 온도",
    "climateCurrent": "현재 {{temperature}} · {{state}}",
    "climateModes": {
      "off": "끄기",
      "cooling": "냉방",
      "heating": "난방",
    },
    "climateApply": "공조 적용",
    "envelopeAria": "고도 포락선 — 최저 {{min}} m 에서 최대 {{max}} m 사이로 비행",
    "obstacle": "장애물 감지",
    "obstacleOn": "켜짐",
    "obstacleNote": "끄기는 이 화면에서 보내지 않습니다",
    "kmz": "KMZ 업로드",
    "kmzSelect": "KMZ 파일 고르기",
    "kmzNote": "올린 경로는 계획 목록에 읽기 전용으로 들어갑니다. 고치지 않으므로 위험 지역을 지나면 막히고, 고도 포락선 검증도 받습니다",
    "kmzOnly": "KMZ(.kmz) 파일만 올릴 수 있습니다",
    "kmzDone": "「{{name}}」을(를) 가져왔습니다",
  },
  "map": {
    "flatBase3d": "3D 산출물이 없어 위성 바탕(지형 없음) 위에 그립니다",
    "dock": "{{name}} 독",
    "aircraft": "{{name}} 기체",
    "readOnly3d": "3D 는 보기 전용입니다 — 그리기는 2D 에서 합니다",
  },
  "units": {
    "meters": "{{value}} m",
    "kilometers": "{{value}} km",
    "celsius": "{{value}} ℃",
    "percent": "{{value}}%",
    "mps": "{{value}} m/s",
  },
} as const;

export default drone;
